var render, staticRenderFns
import script from "./edit-access-permissions-constants-mixin.vue?vue&type=script&lang=ts&"
export * from "./edit-access-permissions-constants-mixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports